
import React from "react";
import { Button } from "@/components/ui/button";
import { X, FileText } from "lucide-react";

interface AttachmentPreviewProps {
  imagePreview: string | null;
  fileType: string | null;
  fileName: string | null;
  onRemove: () => void;
}

const AttachmentPreview: React.FC<AttachmentPreviewProps> = ({
  imagePreview,
  fileType,
  fileName,
  onRemove,
}) => {
  if (!imagePreview) return null;
  
  const isPdf = fileType === "application/pdf";
  
  return (
    <div className="relative mt-2 inline-block">
      {isPdf ? (
        <div className="border border-gray-200 rounded-md p-3 bg-gray-50 flex items-center gap-2">
          <FileText className="h-6 w-6 text-blue-600" />
          <span className="text-sm font-medium">{fileName || "PDF bestand"}</span>
        </div>
      ) : (
        <img
          src={imagePreview}
          alt="Voorvertoning"
          className="max-h-[200px] rounded-md"
        />
      )}
      <Button
        variant="destructive"
        size="icon"
        className="absolute top-1 right-1 h-6 w-6"
        onClick={onRemove}
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default AttachmentPreview;
